module.exports = __webpack_public_path__ + "static/media/coupon-expired-stamp.7bce4a13.svg";